export default __webpack_public_path__ + "static/how_it_works_step_7_desktop_tablet-5b878f03a17a2c069c069ccd34700b51.webp";